export default {"src":"/_next/static/media/chairs.65bc09a9.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};